up.compiler('.video-section', (element) => {

  function onPlayVideo(_event, playingVideo) {
    getVideos().forEach((video) => {
      if (video === playingVideo) return
      if (video.paused) return

      video.pause()
    })
  }

  function getVideos() {
    return element.querySelectorAll('video')
  }

  up.on(element, 'play', 'video', { capture: true }, onPlayVideo)

})
